export function requestIdleCallbackPolyfill(
  callback: IdleRequestCallback
): ReturnType<typeof setTimeout> {
  return setTimeout(() => {
    callback({
      didTimeout: false,
      timeRemaining: () => 15
    });
  }, 1);
}

export function cancelIdleCallbackPolyfill(
  id: ReturnType<typeof setTimeout>
): void {
  clearTimeout(id);
}

export const requestIdleCallback =
  window.requestIdleCallback || requestIdleCallbackPolyfill;
export const cancelIdleCallback =
  window.cancelIdleCallback || cancelIdleCallbackPolyfill;
